import { isFeatureEnabled } from 'owa-feature-flags';
import { FeatureNames, FlightNames } from 'owa-mail-smart-pill-features';
import { SmartPillData } from 'owa-smart-pill';
import { isTimePanelWithToDoFeaturesAvailable } from 'owa-time-panel-bootstrap';
import { trace } from 'owa-trace';

export default function isPillTypeEnabled(pill: SmartPillData): boolean {
    const featureName: string = pill.featureName;

    if (featureName === FeatureNames.SmartReply) {
        return isFeatureEnabled(FlightNames.SmartReply);
    }

    if (featureName === FeatureNames.SmartTime) {
        return isFeatureEnabled(FlightNames.SmartReplyWithCustomMeetingTime);
    }

    if (featureName === FeatureNames.SmartDoc) {
        return isFeatureEnabled(FlightNames.SmartDoc);
    }

    if (featureName === FeatureNames.SmartTodo || featureName === FeatureNames.SmartReminder) {
        // Smart Todo is the first smart feature that has dependency on another feature (Time Panel)
        // Do not surface Smart Todo experience to the user if its dependent feature is unavailable.
        const isPanelAvailable = isTimePanelWithToDoFeaturesAvailable();
        if (!isPanelAvailable) {
            trace.info(
                '[isPillTypeEnabled] Disable Smart Todo - Time Panel and/or To Do is unavailable.'
            );
        }

        return isFeatureEnabled(FlightNames.SmartTask) && isPanelAvailable;
    }

    // We don't have any other pill types, so if we're here, log a trace and return false.
    trace.info(`[isPillTypeEnabled] Unknown pill type: ${featureName}`);
    return false;
}
